<div [formGroup]="form" class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <label for="faultCode" class="font-semibold w-full"
      >{{ "fault_allocation.fault_lists.faults.faultCode" | translate }}*</label
    >
    <input
      pInputText
      id="faultCode"
      formControlName="faultCode"
      autocomplete="off"
      maxlength="100"
      [readonly]="isSaving()"
    />
    @if (form.controls.faultCode.hasError("maxlength")) {
      <small class="p-error">{{ "fault_allocation.fault_lists.faults.fault_code_too_long" | translate }}</small>
    }
    @if (serverErrors()["faultCode"]) {
      <small class="p-error">{{ serverErrors()["faultCode"] }}</small>
    }
  </div>

  <div class="flex flex-column gap-2 mb-3">
    <label for="faultType" class="font-semibold w-full"
      >{{ "fault_allocation.fault_lists.faults.faultType" | translate }}*</label
    >
    <p-select
      inputId="faultType"
      formControlName="faultType"
      [options]="faultTypeOptions"
      [disabled]="isSaving()"
      appendTo="body"
      class="w-full"
    />
    @if (serverErrors()["faultType"]) {
      <small class="p-error">{{ serverErrors()["faultType"] }}</small>
    }
  </div>

  <div class="flex flex-column gap-2 mb-3" style="grid-column: 1/3">
    <div class="list-compact-rows">
      <div class="flex justify-content-between">
        <span class="listTitle">{{ "fault_allocation.fault_lists.faults.translations.title" | translate }}*</span>
        <app-svg-icon
          (click)="onTranslationAdd()"
          iconName="plus"
          iconColor="primary"
          iconSize="xs"
          class="pointer"
        ></app-svg-icon>
      </div>

      @if (serverErrors()["translations"]) {
        <small class="p-error">{{ serverErrors()["translations"] }}</small>
      }

      <div class="listItems">
        @for (translation of fault().translations; let i = $index; track translation.languageCode ?? i) {
          <div class="listRow">
            <span>{{ translation.languageName || translation.languageCode }}</span>
            <div class="actionButtonGroup">
              <app-svg-icon
                (click)="onTranslationEdit(translation)"
                iconName="edit"
                iconColor="primary"
                iconSize="xs"
                class="pointer"
              ></app-svg-icon>
              @if (canDeleteTranslation()) {
                <app-svg-icon
                  (click)="onTranslationDelete(i)"
                  iconName="trash"
                  iconColor="primary"
                  iconSize="xs"
                  class="pointer"
                ></app-svg-icon>
              }
            </div>
            @if (getTranslationError(i)) {
              <small class="p-error">{{ getTranslationError(i) }}</small>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @if (serverErrors()["_global"]) {
    <small class="p-error">{{ serverErrors()["_global"] }}</small>
  }

  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button buttonText="common.cancel" [disabled]="isSaving()" (click)="closeDialog()"></app-button>
    <app-button buttonText="common.save" [disabled]="!canSave()" (click)="save()"></app-button>
  </div>
</div>
